import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import {toggleNavCollapsed} from '../../../../redux/actions';
import {useDispatch} from 'react-redux';
import Hidden from '@material-ui/core/Hidden';
import HorizontalNav from '../../Navigation/HorizontalNav';
import Box from '@material-ui/core/Box';
import useStyles from './AppHeader.style';
import NotificationBar from './NotificationBar';
import clsx from 'clsx';
import Notifications from '../../Notifications';
import Transactions from '../../Transactions';
import UserInfo from '../UserInfo';
import AppLogo from '../../../../shared/components/AppLogo';
import {useHistory} from 'react-router-dom';

interface AppHeaderProps {}

const AppHeader: React.FC<AppHeaderProps> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <>
      <AppBar position='relative'>
        <NotificationBar />
        <Toolbar className={classes.headerMain}>
          <Box className={classes.headerContainer}>
            <Box className={classes.headerMainFlex}>
              <Hidden mdUp>
                <IconButton
                  edge='start'
                  className={classes.menuButton}
                  color='inherit'
                  aria-label='open drawer'
                  onClick={() => dispatch(toggleNavCollapsed())}>
                  <MenuIcon className={classes.menuIconRoot} />
                </IconButton>
              </Hidden>

              <AppLogo
                onClick={() => {
                  history.push('/dashboard');
                }}
              />
              <Box className={classes.grow} />
              <Box className={clsx(classes.sectionDesktop)}>
                <Transactions />
                <Notifications />
              </Box>
              <UserInfo />
            </Box>
          </Box>
        </Toolbar>
        <Hidden smDown>
          <Box className={classes.headerNav}>
            <Box className={classes.headerContainer}>
              <HorizontalNav />
            </Box>
          </Box>
        </Hidden>
      </AppBar>
    </>
  );
};
export default AppHeader;
